/** Presentational view-models for the Jobs (requisitions) screens. */
import type { Tone } from '../../theme/tone';
import type { ReqStatus, RemotePolicy } from '../../schemas/hire/requisitionV2';

export function reqStatusVM(status: ReqStatus): { tone: Tone; label: string } {
  switch (status) {
    case 'active': return { tone: 'success', label: 'Active' };
    case 'on_hold': return { tone: 'warn', label: 'On hold' };
    case 'closed': return { tone: 'neutral', label: 'Closed' };
    case 'draft':
    default: return { tone: 'neutral', label: 'Draft' };
  }
}

export const REMOTE_LABEL: Record<RemotePolicy, string> = {
  onsite: 'On-site',
  hybrid: 'Hybrid',
  remote: 'Remote',
};

/** "min–max y" experience band label. */
export function expBand(min: number, max: number | null): string {
  if (max == null) return `${min}+ y`;
  return `${min}–${max} y`;
}
